"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const emotion_1 = require("emotion");
const default_1 = __importDefault(require("../themes/default"));
const { colors, fontSize, lineHeight } = default_1.default;
exports.h1 = emotion_1.css `
  font-size: ${fontSize.lg};
  line-height: ${lineHeight.lg};
  color: ${colors.white};
`;
exports.h2 = emotion_1.css `
  font-size: ${fontSize.md};
  line-height: ${lineHeight.lg};
  color: ${colors.white};
`;
exports.h3 = emotion_1.css `
  font-size: ${fontSize.sm};
  line-height: ${lineHeight.lg};
  color: ${colors.white};
`;
exports.paragraph = emotion_1.css `
  font-size: ${fontSize.sm};
  line-height: ${lineHeight.md};
  color: ${colors.white};
`;
exports.smallText = emotion_1.css `
  font-size: ${fontSize.xs};
  line-height: ${lineHeight.lg};
  color: ${colors.white};
`;
//# sourceMappingURL=style.js.map